module.exports = __webpack_public_path__ + "img/bamba_yes.471ffdba.png";